import React from "react";
import { Reveal } from "@/components/Reveal";

export default function SectionLabel({ overline, title, subtitle, align = "left", className = "" }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`${alignCls} max-w-3xl ${className}`}>
      <Reveal>
        <div className={`overline mb-4 ${align === "center" ? "flex justify-center" : ""}`}>
          <span>{overline}</span>
        </div>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="font-display text-3xl md:text-5xl text-white leading-[1.08] tracking-tight">
          {title}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.12}>
          <p className="mt-5 text-base md:text-lg text-white/70 leading-relaxed">{subtitle}</p>
        </Reveal>
      )}
    </div>
  );
}
